/** @format */

export interface CheckoutError {
  AppId: string;
  Authenticated: string;
  CartCookie?: string;
  CartId: string;
  Chain: string;
  CheckoutAccessKey?: string;
  CheckoutKey: string;
  CheckoutStep: string;
  DSG_UID: string;
  Error: Error;
  ErrorMessage: string;
  OrderNumber: string;
  PageType: string;
  RedirectMessage?: string;
  RedirectPath?: string;
  ReferringPageURL: string;
  X_HREF: string;
}
